import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Platform } from '../../../models/platform.model';
import { PlatformService } from '../../../services/platform.service';
import { PlatformModalComponent } from '../../../components/platform-modal/platform-modal.component';

@Component({
  selector: 'app-platforms-page',
  templateUrl: './platforms-page.component.html',
  styleUrl: './platforms-page.component.scss'
})
export class PlatformsPageComponent {

  /* Filas fantasma del esqueleto. Solo le dan largo al cuerpo de la tabla
     mientras platformService.loading es true: la p-table NUNCA se desmonta, así
     que el encabezado y las acciones se pintan de inmediato y el contenido no
     salta cuando llega la respuesta. Se usa esto en lugar de [loading] de
     PrimeNG porque ese input pinta una máscara que bloquea toda la tabla. */
  public skeletonRows: null[] = [null, null, null, null, null];

  constructor(
    public platformService: PlatformService,
    private modalService: NgbModal,
    private router: Router,
  ) {

  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(
    platform: Platform
  ) {

    const flag = confirm(
      `¿Está seguro que desea borrar la plataforma "${platform.sku}"?`
    );

    if(flag) {
      await this.platformService.delete(
        platform
      );
    }

  }

  /*
   ██████╗  ██████╗   ████████╗ ██████╗   ██████╗ ███████╗████████╗ █████╗ ██╗██╗
  ██╔════╝ ██╔═══██╗  ╚══██╔══╝██╔═══██╗  ██╔══██╗██╔════╝╚══██╔══╝██╔══██╗██║██║
  ██║  ███╗██║   ██║     ██║   ██║   ██║  ██║  ██║█████╗     ██║   ███████║██║██║
  ██║   ██║██║   ██║     ██║   ██║   ██║  ██║  ██║██╔══╝     ██║   ██╔══██║██║██║
  ╚██████╔╝╚██████╔╝     ██║   ╚██████╔╝  ██████╔╝███████╗   ██║   ██║  ██║██║███████╗
   ╚═════╝  ╚═════╝      ╚═╝    ╚═════╝   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝╚══════╝

  */
  goToDetail(
    platform: Platform,
    event?: Event,
  ) {

    /* Solo llega evento desde los atajos de teclado de la fila. El clic del
       mouse no lo manda porque cualquier celda es un origen valido. */
    if (event) {

      /* Enter y Espacio disparados sobre los botones de la celda de acciones
         burbujean hasta el <tr>: si el evento no nacio en la fila misma, la
         accion le pertenece al boton y la fila no debe navegar. */
      if (event.target !== event.currentTarget) {
        return;
      }

      /* Evita que la barra espaciadora haga scroll de la pagina al activar. */
      event.preventDefault();

    }

    this.router.navigate(
      ['/dashboard/platforms', platform.platformId]
    );

  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  open(
    platform?: Platform,
  ) {
    const modalRef = this.modalService.open(
      PlatformModalComponent
    );

    modalRef.componentInstance.platform = platform;

  }

}
